var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import FormInput from '@/common/components/Form/FormInput.vue';
import FormFileUpload from '@/common/components/Form/FormFileUpload.vue';
import FormModal from '@/common/components/Modal/FormModal.vue';
import { postCompleteCompany, postCompanyOrc, getCompanyInfo } from 'src/common/api/common';
var EditUserInfoModal = /** @class */ (function (_super) {
    __extends(EditUserInfoModal, _super);
    function EditUserInfoModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /* Prop */
        _this.visible = false;
        _this.requesting = false;
        _this.formData = {};
        _this.rules = {
            'name': [{ required: true, whitespace: true, message: '请输入公司名称', trigger: 'blur' }],
        };
        return _this;
    }
    /* methods */
    EditUserInfoModal.prototype.init = function () {
        var _this = this;
        this.visible = true;
        this.$nextTick(function () {
            _this.getCompanyInfo();
        });
    };
    // 获取公司信息
    EditUserInfoModal.prototype.getCompanyInfo = function () {
        var _this = this;
        getCompanyInfo({}).then(function (response) {
            _this.formData = Object.assign({}, _this.getOriFormData(), {
                name: response.name,
                files: response.businessLicenseUrl ? [{ url: response.businessLicenseUrl }] : [],
            });
        });
    };
    EditUserInfoModal.prototype.uploadComplete = function (files) {
        var _this = this;
        this.formData.files = files;
        this.formData.businessLicenseUrl = Array.isArray(files) && files.length ? files[0].url : null;
        this.formData.businessLicenseUrl && postCompanyOrc({ url: this.formData.businessLicenseUrl }).then(function (response) {
            _this.formData.name = response.companyName;
        });
    };
    EditUserInfoModal.prototype.getOriFormData = function () {
        return {
            name: null,
            files: [],
            businessLicenseUrl: null,
        };
    };
    EditUserInfoModal.prototype.submit = function () {
        var _this = this;
        this.$refs.formData.validate(function (valid) {
            if (!valid) {
                _this.$message({
                    type: 'error',
                    message: "\u4FE1\u606F\u672A\u586B\u5199\u5B8C\u6574\uFF0C\u8BF7\u68C0\u67E5",
                });
                return false;
            }
            else {
                _this.requesting = true;
                var _a = _this.formData, name = _a.name, businessLicenseUrl = _a.businessLicenseUrl;
                var params = {
                    name: name, businessLicenseUrl: businessLicenseUrl,
                };
                postCompleteCompany(params).then(function () {
                    _this.$message.success('提交成功！');
                    _this.$store.dispatch('$_UpdateUserInfo');
                    _this.visible = false;
                }).finally(function () {
                    _this.requesting = false;
                });
            }
        });
    };
    EditUserInfoModal = __decorate([
        Component({
            components: {
                FormInput: FormInput,
                FormFileUpload: FormFileUpload,
                FormModal: FormModal,
            },
        })
    ], EditUserInfoModal);
    return EditUserInfoModal;
}(Vue));
export default EditUserInfoModal;
